'use client';
import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useNavigation } from '@/contexts/NavigationContext';
import TopProgressBar from './TopProgressBar';
import VividSpinner from './VividSpinner';

export default function NavigationLoader() {
  const pathname = usePathname();
  const { isNavigating, navLabel, endNavigation } = useNavigation();

  // End navigation whenever the route actually changes
  useEffect(() => {
    endNavigation();
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  // Safety valve: if the pathname never changes (same-route click),
  // dismiss the overlay after 6 seconds so it never gets stuck
  useEffect(() => {
    if (!isNavigating) return;
    const t = setTimeout(() => endNavigation(), 6000);
    return () => clearTimeout(t);
  }, [isNavigating]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <TopProgressBar />
      {isNavigating && (
        <div className="fixed inset-0 z-[9998] flex flex-col items-center justify-center bg-white/75 backdrop-blur-sm animate-fade-in">
          <VividSpinner size={110} />
          <p className="mt-6 text-sm font-semibold text-gray-500 tracking-wide">{navLabel}</p>
        </div>
      )}
    </>
  );
}
